import React, { useEffect } from 'react';
import {
  useSnackbar,
  Snackbar as FrontonSnackbar,
  Snack,
  SnackCloseButton,
  Icon,
  useMediaQuery,
} from 'fronton-react';
import { useAppSelector, useAppDispatch } from 'common/hooks';
import { WarningIcon } from '@fronton/icons-react';
import { snackbarSlice } from 'store/snakbar/snakbar-slice';

export const Snackbar = () => {
  const isMobile = useMediaQuery({
    maxWidth: 600,
  });
  const { state, addSnack, removeSnack } = useSnackbar();
  const dispatch = useAppDispatch();
  const snackbarData = useAppSelector(snackbarSlice.selectors.selectSnackbarData);

  useEffect(() => {
    if (snackbarData !== null) {
      const data = {
        id: `${Math.floor(Math.random() * 100)}`,
        title: snackbarData.title,
        content: snackbarData.content,
        type: 'error',
      };
      addSnack(data);

      dispatch(snackbarSlice.actions.clearSnackbarData());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [snackbarData]);

  return (
    <FrontonSnackbar verticalPosition={isMobile ? 'top' : 'bottom'} data-testid="snakbar-root">
      {state.map(({ id, title, content, type, wide }) => (
        <Snack
          key={id}
          id={id}
          header={title}
          paragraph={content}
          icon={
            <Icon size={24}>
              <WarningIcon type="outline" color="control-invert" />
            </Icon>
          }
          variant={type}
          wideButton={wide}
          autoHideTimer={3000}
          closeButton={<SnackCloseButton onClick={() => removeSnack(id)} />}></Snack>
      ))}
    </FrontonSnackbar>
  );
};
